import { render, staticRenderFns } from "./LmProcedureCustomization.vue?vue&type=template&id=2ab156be&scoped=true&"
import script from "./LmProcedureCustomization.vue?vue&type=script&lang=js&"
export * from "./LmProcedureCustomization.vue?vue&type=script&lang=js&"
import style0 from "./LmProcedureCustomization.vue?vue&type=style&index=0&id=2ab156be&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab156be",
  null
  
)

export default component.exports